import React from 'react';
import { Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import AuditTable from './../AuditTable/AuditTable';
import Logic from '../../Logic';
import CandidatesTableProgressBar from './../CandidatesTableProgressBar/CandidatesTableProgressBar';

const CandidatesTable = (props) => {
    const [actionButtonsDisabled, setActionButtonsDisabled] = React.useState(false);
    const [env, setEnv] = React.useState(null);
    let logic = new Logic();

    React.useEffect(() => {
        logic.getInit((res) => {
            setEnv(res.data.environment);
        });
    }, []);

    // const statusNames = ['לא ידוע', 'חדש', 'ממתין למילוי טפסים בשירות עצמי', 'שירות משרדי ממתין לצרופות', 'סיום'];

    // function toggleAudit(identityNumber){
    //     var row = document.getElementById('audit_' + identityNumber);
    //     if(row !== null){
    //         row.classList.toggle('show');
    //     }
    // }

    // function toggleDropdown(identityNumber){
    //     var row = document.getElementById('dropdown_' + identityNumber);
    //     if(row !== null){
    //         row.classList.toggle('show');
    //     }
    // }

    // function formatDate(date){
    //     var d = new Date(Date.parse(date));
    //     return d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
    // }

    function toggleDetails(id) {
        let row = document.getElementById('details_' + id);
        let toggler = document.getElementById('toggler_' + id);
        let footer = document.getElementById('footer_' + id);
        if (row !== null) {
            row.classList.toggle('show');
            footer.classList.toggle('show');
            if (toggler.classList.contains('fa-chevron-down')) {
                toggler.classList.remove('fa-chevron-down');
                toggler.classList.add('fa-chevron-up');
            } else {
                toggler.classList.remove('fa-chevron-up');
                toggler.classList.add('fa-chevron-down');
            }
        }
    }

    function redirectToEdit(id) {
        props.history.push('/edit/' + id);
    }

    function showApproveButton(candidate) {
        //do not show the approve button when there is some response or status is not at last step
        return candidate.status === 'ממתין לאימות נאמן ביטחון' || (candidate.step === 7 && candidate.status === 'חדש') || candidate.status === 'טופס לא תקין'; // (candidate.status ==== 'שירות משרדי' && candidate.step === 7)
        //return candidate.status !== 'ממתין לתשובת משהב"ט' &&  candidate.status !== 'קיימת בקשה פעילה עם נתונים זהים' && candidate.step === 7
        // return (candidate.status === 'חדש' || candidate.status === 'שירות משרדי' || candidate.status === 'שירות עצמי' || candidate.status === 'ממתין לאימות נאמן ביטחון') && candidate.step === 7;
    }

    function showEditButton(candidate) {
        // candidate.status === 'שירות עצמי' ||
        if (env === 'QA') {
            return candidate.status === 'חדש' || candidate.status === 'שירות עצמי' || candidate.status === 'שירות משרדי' || candidate.status === 'ממתין לאימות נאמן ביטחון' || candidate.status === 'טופס לא תקין';
        }
        return candidate.status === 'חדש' || candidate.status === 'שירות משרדי' || candidate.status === 'ממתין לאימות נאמן ביטחון' || candidate.status === 'טופס לא תקין';
    }

    function renderCards() {

        if (props.data) {
            let items = props.data.map((a, i) => (<div key={i}>
                <div className="card" style={{ marginBottom: '20px' }}>
                    <div className="card-body" style={{ lineHeight: '2.5' }}>
                        <div className="float-right"><FontAwesome style={{ cursor: 'pointer' }} id={"toggler_" + a.authKey} name="chevron-down" onClick={() => toggleDetails(a.authKey)} /></div>
                        <div className="d-md-none d-sm-block" style={{ clear: 'both' }}></div>
                        <div className="col-sm-6 col-md-1 float-right"><div className="d-md-none"><label>שם</label></div>{a.firstName} {a.lastName}</div>

                        <div className="col-sm-6 col-md-1 float-right"><div className="d-md-none"><label>ת"ז</label></div>{a.identityNumber}</div>
                        <div className="col-sm-6 col-md-1 float-right"><div className="d-md-none"><label>נייד</label></div>{a.mobilePhone}</div>
                        <div className="col-sm-6 col-md-2 float-right"><div className="d-md-none"><label>דוא"ל</label></div>{a.privateEmail}</div>
                        <div className="col-sm-6 col-md-1 float-right"><div className="d-md-none"><label>תפקיד</label></div>{a.position}</div>
                        <div className="col-sm-6 col-md-1 float-right"><div className="d-md-none"><label>ת. יצירה</label></div>{logic.formatDate(a.createdOn)}</div>
                        <div className="col-sm-6 col-md-1 float-right"><div className="d-md-none"><label>פג בתאריך</label></div>{logic.formatDate(a.expireOn)}</div>
                        <div className="col-sm-6 col-md-1 float-right" style={{ marginTop: '12px' }}><div className="d-md-none"><label>שלב</label></div><CandidatesTableProgressBar candidate={a} /></div>
                        <div className="col-sm-6 col-md-1 float-right"><div className="d-md-none"><label>סטטוס</label></div>{a.status}</div>

                        <div className="d-md-none d-sm-block" style={{ clear: 'both' }}></div>

                        {showEditButton(a) ? <div className="col-sm-6 col-md-1 float-right d-md-block d-none" style={{ borderRight: '1px solid #ddd', width: '5%' }}><Button color="link" style={{ fontSize: '11pt' }} disabled={actionButtonsDisabled} onClick={() => redirectToEdit(a.authKey)}><FontAwesome name="edit" /> {a.step === 0 ? 'מילוי טפסי בדיקה' : 'עריכה'}</Button></div> : null}
                        <div className="d-md-block col-md-1 float-right d-none" style={{ width: '5%' }}><a className="btn btn-link" style={{ fontSize: '11pt' }} onClick={() => props.notify(true, 'מכין טפסים להורדה...')} href={logic.getDownloadFilledFormsUrl(a.authKey)} download><FontAwesome name="file-pdf" /> טפסים</a></div>
                        {showApproveButton(a) ? <div className="col-sm-6 col-md-1 float-right d-md-block d-none" style={{ width: '5%' }}><Button color="link" style={{ fontSize: '11pt' }} disabled={actionButtonsDisabled} onClick={() => props.onConfirmClicked(a, setActionButtonsDisabled)}><FontAwesome name="check" /> אשר מועמד</Button></div> : null}

                        <div className="d-md-block d-none" style={{ clear: 'both' }}></div>

                        <div id={"details_" + a.authKey} className="collapse" style={{ marginTop: '2rem' }}>
                            <h3>תיעוד פעולות</h3>
                            <AuditTable audits={a.audits} />

                            <div className="d-md-none d-sm-block" style={{ borderTop: '1px solid #ddd' }}>
                                {showEditButton(a) ? <div className="col-sm-6 d-md-none d-block float-right" style={{ borderLeft: '1px solid #ddd', marginTop: '1rem' }}><Button color="link" disabled={actionButtonsDisabled} onClick={() => redirectToEdit(a.authKey)}><FontAwesome name="edit" /> {a.step === 0 ? 'מילוי טפסי בדיקה' : 'עריכה'}</Button></div> : null}
                                {showApproveButton(a) ? <div className="col-sm-6 d-md-none d-block float-right" style={{ marginTop: '1rem' }}><Button disabled={actionButtonsDisabled} color="link" onClick={() => props.onConfirmClicked(a, setActionButtonsDisabled)}><FontAwesome name="check" /> אשר מועמד</Button></div> : null}

                                <div className="col-sm-6 d-md-none d-block float-right" style={{ marginTop: '1rem' }}><a className="btn btn-link" onClick={() => props.notify(true, 'מכין טפסים להורדה...')} href={logic.getDownloadFilledFormsUrl(a.authKey)} download><FontAwesome name="file-pdf" /> טפסים</a></div>

                                <div className="col-sm-6 d-md-none d-block float-right" style={{ borderLeft: '1px solid #ddd', marginTop: '1rem' }}><Button color="link" disabled={actionButtonsDisabled} onClick={() => props.onReInviteClicked(a, setActionButtonsDisabled)}><FontAwesome name="sms" /> שלח זימון</Button></div>
                                <div className="col-sm-6 d-md-none d-block float-right" style={{ marginTop: '1rem' }}><Button color="link" disabled={actionButtonsDisabled} onClick={() => props.onExtendClicked(a, setActionButtonsDisabled)}><FontAwesome name="calendar-week" /> הארכת תוקף</Button></div>
                                <div className="col-sm-6 d-md-none d-block float-right" style={{ marginTop: '1rem' }}><Button color="link" disabled={actionButtonsDisabled} onClick={() => props.onCancelClicked(a, setActionButtonsDisabled)}><FontAwesome name="times" /> ביטול בקשה</Button></div>
                                <div className="d-md-none d-block" style={{ clear: 'both' }}></div>
                            </div>
                        </div>
                    </div>

                    <div className="card-footer collapse" id={"footer_" + a.authKey}>
                        <div className="d-md-none d-sm-block text-center"><FontAwesome style={{ cursor: 'pointer' }} name="chevron-up" onClick={() => toggleDetails(a.authKey)} /></div>
                        <div className="col-sm-1 d-none d-md-block float-right"><Button color="link" disabled={actionButtonsDisabled} onClick={() => props.onReInviteClicked(a, setActionButtonsDisabled)}><FontAwesome name="sms" /> שלח זימון</Button></div>
                        <div className="col-sm-1 d-none d-md-block float-right"><Button color="link" disabled={actionButtonsDisabled} onClick={() => props.onExtendClicked(a, setActionButtonsDisabled)}><FontAwesome name="calendar-week" /> הארכת תוקף</Button></div>
                        <div className="col-sm-1 d-none d-md-block float-right"><Button color="link" disabled={actionButtonsDisabled} onClick={() => props.onCancelClicked(a, setActionButtonsDisabled)}><FontAwesome name="times" /> ביטול בקשה</Button></div>
                    </div>
                </div>
            </div>));
            return items;
        }
        return null;
    }

    return (
        <div className="col-md-12" style={{ display: 'flex', flexDirection: 'column', flexWrap: 'nowrap', justifyContent: 'flex-start' }}>
            {props.data ?
                <>
                    <div className="card d-none d-md-block" style={{ marginBottom: '20px', backgroundColor: '#EAEDF8', lineHeight: '0.5', boxShadow: 'none' }}>
                        <div className="card-body">
                            <div className="float-right">&nbsp;&nbsp;&nbsp;&nbsp;</div>
                            <div className="col-sm-1 float-right">שם</div>
                            <div className="col-sm-1 float-right">ת"ז</div>
                            <div className="col-sm-1 float-right">נייד</div>
                            <div className="col-sm-2 float-right">דוא"ל</div>
                            <div className="col-sm-1 float-right">תפקיד</div>
                            <div className="col-sm-1 float-right">ת. יצירה</div>
                            <div className="col-sm-1 float-right">פג בתאריך</div>
                            <div className="col-sm-1 float-right">שלב</div>
                            <div className="col-sm-1 float-right">סטטוס</div>
                            <div className="col-sm-1 float-right">&nbsp;</div>
                            <div className="float-right">&nbsp;</div>
                        </div>
                    </div>
                    {renderCards()}
                </> : null}
        </div>
    );
};

export default CandidatesTable;